/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { type Meta, type StoryObj } from '@storybook/react-vite';

import { Radio } from '../../index';
import {
  RadioControlled,
  RadioControlledSrc,
  RadioCustomLabel,
  RadioCustomLabelSrc,
  RadioDefault,
  RadioDefaultSrc,
  RadioDisabled,
  RadioDisabledSrc,
  RadioHasLabelBefore,
  RadioHasLabelBeforeSrc,
  RadioNoLabel,
  RadioNoLabelSrc,
  RadioTruncatedLabel,
  RadioTruncatedLabelSrc,
} from '.';

const componentMeta: Meta<typeof Radio> = {
  component: Radio,
  decorators: [
    (Story) => (
      <div className="n-flex n-justify-center">
        <Story />
      </div>
    ),
  ],
  id: 'components-radio',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/Radio',
};

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Default: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioDefaultSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioDefault,
};

export const NoLabel: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioNoLabelSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioNoLabel,
};

export const HasLeadingLabel: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioHasLabelBeforeSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioHasLabelBefore,
};

export const Disabled: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioDisabledSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioDisabled,
};

export const CustomLabel: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioCustomLabelSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioCustomLabel,
};

export const TruncatedLabel: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioTruncatedLabelSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioTruncatedLabel,
};

export const Controlled: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: RadioControlledSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: RadioControlled,
};
